import IconDrag from '@assets/icons/drag.svg?react';
import IconMinus from '@assets/icons/minus.svg?react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box, IconButton, Theme } from '@mui/material';
import { useState } from 'react';

import { TransformedStructure } from './fieldsModalTypes';

const style = {
 cursor: 'grab',
 //  marginBottom: '8px',
 display: 'flex',
 alignItems: 'center',
 px: '12px',
 py: 1,
 background: (theme: Theme) => theme.palette.kemek.lightBlue,
 borderRadius: '4px',
};

export const TempField = ({
 item,
}: {
 item: TransformedStructure | undefined;
}) => <Box sx={style}>{item?.Translation}</Box>;

export const DraggableField = ({
 item,
 highlight,
 depth,
 removeSelectedField,
}: {
 item: TransformedStructure;
 highlight: string | React.ReactNode;
 depth: number;
 removeSelectedField?: (id: string) => void;
}) => {
 const [isHovered, setIsHovered] = useState(false);
 const {
  attributes,
  listeners,
  setNodeRef,
  transform,
  transition,
  isDragging,
 } = useSortable({ id: item.Key });

 const dynamicStyle = {
  ...style,
  opacity: isDragging ? 0.5 : 1,
  transform: CSS.Transform.toString(transform),
  transition,
  display: 'flex',
  alignItems: 'center',
  fontSize: '12px',
  justifyContent: 'space-between',
  ml: depth > 1 ? depth * 0.8 : 0,
 };

 const showIcon = isHovered || isDragging;

 return (
  <Box
   ref={setNodeRef}
   sx={dynamicStyle}
   {...attributes}
   {...listeners}
   data-no-dnd="true"
   onMouseEnter={() => setIsHovered(true)}
   onMouseLeave={() => setIsHovered(false)}
  >
   <Box sx={{ wordBreak: 'break-all' }}>{highlight}</Box>
   {removeSelectedField ? (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
     {showIcon ? <IconDrag style={{ width: 24, height: 24 }} /> : null}
     <IconButton
      sx={{ width: 26, height: 26 }}
      onClick={() => removeSelectedField(item.Key)}
      onPointerDown={(event) => event.stopPropagation()}
     >
      <IconMinus style={{ width: 24, height: 24 }} />
     </IconButton>
    </Box>
   ) : null}
  </Box>
 );
};
